import React, {useContext, useEffect, useState} from 'react';
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import Slider from "react-slick";
import {useParams} from "react-router-dom";
import 'react-datepicker/dist/react-datepicker.css';
import {axios} from "../axios";
import {LangContext} from "../App";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Seo from "../components/Seo/Seo";
import {faLocationDot} from "@fortawesome/free-solid-svg-icons";
import Callback from "../components/CallBack/Callback";
import { processImageString, updateSliderSettingsWithImages, createSliderImages } from "../utils/sliderUtils";

const ApartmentSingle = () => {
    const id = useParams().id
    const [data,setData] = useState()
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/apartment/${id}`)
            .then(res => setData(res.data))
            .catch(() => setData(null))
    },[id,lang])
    const [sliderSettings,setSlidersettings] = useState({
        dots: true,
        infinite: true,
        speed: 500,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical:false,
        customPaging: (i) => <div style={{backgroundImage:`url(${i})`}}></div>,
    })
    useEffect(()=>{
        const images = processImageString(data?.images);
        if(images.length > 0){
            const sliderData = updateSliderSettingsWithImages(sliderSettings, images);
            setSlidersettings(sliderData);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- loop
    },[data])
    const handleSliderImages = ()=>{
        return createSliderImages(data?.images, data?.title);
    }
    return (
        <div className='tour-page'>
            <Seo
                pageKey="apartments"
                title={data?.title}
                description={data?.description?.replace(/<[^>]*>?/gm, '').substring(0, 160)}
            />
            <div className="center-wrapper">
                <main>
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="tour-info">
                                <h1 className="tour-title">{data?.title}</h1>
                                <div className="stars">
                                    <div className="star">
                                        <FontAwesomeIcon icon={faLocationDot}/> - {data?.city}
                                    </div>
                                </div>
                                <div className="tour-image version-2">
                                    <Slider {...sliderSettings}>
                                        {handleSliderImages()}
                                    </Slider>
                                </div>
                                <div className="row">
                                    <div className="col-8">
                                        <div className="d-flex flex-column tour-details">
                                            <p>
                                                <b>Country: </b>{data?.country}
                                            </p>
                                            <p>
                                                <b>Address: </b>{data?.address}
                                            </p>
                                        </div>
                                        <div className="main-text" dangerouslySetInnerHTML={{__html:data?.text}}></div>
                                    </div>
                                    <div className="col-4">
                                        <Callback title='Book Apartment' tourType='apartment' tourId={data?.id} tourPrice={data?.price}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default ApartmentSingle;